import { useNode } from '@craftjs/core';
import { upperFirst } from 'lodash';
import { generateOnChange } from 'pages/PageEditor/settingsComponents/settingsHelpers';
import React, { useMemo } from 'react';
import { AutocompleteControl, SliderControl } from '../../settingsComponents';
import {
	colorOptions,
	sizeOptions,
	variantProps
} from './editorLoaderConstants';

const EditorLoaderSettings = () => {
	const {
		size,
		variant,
		color,
		actions: { setProp }
	} = useNode((node) => node.data.props);

	const [onVariantChange, onSizeChange, onColorChange] = useMemo(
		() =>
			['variant', 'size', 'color'].map((attr) =>
				generateOnChange(setProp, attr)
			),
		[setProp]
	);

	return (
		<div>
			<AutocompleteControl
				label={intl.tr('screenEditor.settings.button.variant')}
				setValue={onVariantChange}
				value={variant}
				options={variantProps}
				getOptionLabel={(o: string) => upperFirst(o as string)}
			/>
			<AutocompleteControl
				label={intl.tr('screenEditor.settings.color')}
				setValue={onColorChange}
				value={color}
				options={colorOptions}
				getOptionLabel={(o: string) => upperFirst(o as string)}
			/>
			<SliderControl
				label={intl.tr('screenEditor.settings.button.size')}
				value={size}
				options={sizeOptions}
				setValue={onSizeChange}
				marks
			/>
		</div>
	);
};

export { EditorLoaderSettings };
